export const MODAL_GLOBAL_BOARD_SETTINGS = 'modalGlobalBoardSettings';
export const MODAL_AI_SETTINGS = 'modalAiSettings';
export const MODAL_RUSH_REFRESH = 'modalRushRefresh';
export const MODAL_SUGGESTED_EDITS_PREVIEW = 'modalSuggestedEditsPreview';
export const MODAL_CONFIRM = 'modalConfirm';
export const MODAL_PROBLEM_FLAGS = 'modalProblemFlags';
export const MODAL_PROBLEM_STARS = 'modalProblemStars';
export const MODAL_PROBLEM_FLAGS_OWNER = 'modalProblemFlagsOwner';
export const MODAL_CHANGE_HISTORY = 'modalChangeHistory';
export const MODAL_CHANGE_LEVEL = 'modalChangeLevel';
